import React from 'react';
import ReactMarkdown from 'react-markdown';
import PortfolioAnswer from './PortfolioAnswer';

function Message({ message, onOptionClick, presentation, messageRef }) {
  return (
    <div
      ref={messageRef}
      className={`message ${message.sender}`}
      data-message-id={message.id}
      data-testid={`message-${message.sender}`}
    >
      <div className="message-content">
        {presentation ? (
          <PortfolioAnswer
            presentation={presentation}
            answerId={`portfolio-answer-${message.id}`}
          />
        ) : (
          <ReactMarkdown>{message.text}</ReactMarkdown>
        )}
        {message.followups && message.followups.length > 0 && (
          <div className="follow-up-suggestions">
            <div className="follow-up-prompt">Ask a more specific question</div>
            <div className="follow-up-buttons">
              {message.followups.map((followup, index) => (
                <button
                  key={index}
                  className="follow-up-button"
                  onClick={() => onOptionClick(message.id, followup)}
                  disabled={message.followupsConsumed}
                >
                  {followup}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Message;
